export const AppConfig = {
  DATATABLE_BREAKPOINT: '1300px',
  FORM_IDENTIFIER_PATTERN: '^[a-zA-Z0-9_-]+$',
  FORM_IDENTIFIER_MIN_LENGTH: 6
};
